import * as React from 'react'

import { Button } from '../../components'
import { useModelState } from '../../model-hooks/use-model-state'
import ChartLayout from '../../models/chart_layout'
import { updateSettings } from '../../models/settings'
import utils from '../../utils'

export function ThemeToggleButton({ model }: { model: ChartLayout }) {
  const chartLayoutModel = useModelState(model, { watchProperties: ['theme'] })
  const isDarkMode = model.theme === 'dark'

  const onClick = () => {
    const expires = new Date()
    expires.setMonth(expires.getMonth() + 1)

    const theme = isDarkMode ? 'light' : 'dark'
    chartLayoutModel!.updateAttributes({ theme, settings: updateSettings(chartLayoutModel!, theme) })
    chartLayoutModel!.trigger('theme', chartLayoutModel)
    utils.setCookie('chartsTheme', theme, expires)

    if (isDarkMode) {
      document.documentElement.classList.remove('dark')
    } else {
      document.documentElement.classList.add('dark')
    }
  }

  if (!chartLayoutModel) {
    return null
  }

  return (
    <Button
      theme="headerItem"
      appearance="square"
      data-testid="chart-layout-theme"
      title={isDarkMode ? 'Toggle light mode' : 'Toggle dark mode'}
      onClick={onClick}
      leftContent={isDarkMode ? 'lightMode' : 'darkMode'}
    />
  )
}
